import { API_URL } from "config";
import Http from "util/https";
import { downloadFromUrl } from "../utils/common";

/**
 * ダウンロードするURLを取得
 * @param supplierCd 仕入先コード
 */
export default async function downloadCountCsvUrl(supplierCd: string) {
  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/stock/csv/download`;
  const res = await http.post(url, {code: supplierCd});

  downloadFromUrl(res.data.url, '在庫数データ');

  return res.data;
}